/** When Google Auth succeeds, use its query parameters to complete the login. */
export const authGoogleVerifySpec = {
    uri: '/auth/google-verify',
    method: 'POST',
    allowAnonymous: true,
};
